import { createBrowserRouter, RouterProvider  } from "react-router-dom";
import { useState, useEffect } from 'react';

import ThemeContext from './store/ThemeContext';
import MenuContext from './store/MenuContext';
import LabIDContext from './store/LabIDContext';
import {UploadProvider } from './store/UploadContext';
import { getLabConfig, getMenuType } from './utils/api';
import Root from './layouts/Root';
import Home, {loader as msgLoader} from './pages/Home';
import Cart, {loader as upLoader, action as cartAction } from './pages/Cart';
import AAOE from './pages/AAOEfrm';
import UserProfile, { UserProfileEdit, action as UPAction, loader as UPTFLoader} from './pages/UserProfile';
import ErrorPage from './pages/error';
import TestDetail, {loader as TILoader} from "./pages/TestDetail";
import AvailableTests from "./components/Tests/AvailableTests";
import AvailableTestwithCat from "./components/Tests/AvailableTestwithCat";
import SystemMsg, {loader as sysLoader} from "./pages/SystemMsg";
import Register, { regLoader, newRegAction } from './pages/Register';
import ActivateAccount, { actLoader, activateAccountAction } from './pages/ActivateAccount';
import Login, {loginAction, loader as LoginLoader} from './pages/Login';
import Minor, {NoService, NoServiceSysMsg} from './pages/NoService';
import  { logoutAction } from './pages/Logout';
import ForgotPassword,{action as ForgotPasswordAction} from './pages/ForgotPassword';
import ForgotUsername, {action as ForgotUsernameAction} from './pages/ForgotUsername';
import ResetPassword, {action as ResetPasswordAction} from './pages/ResetPassword';
import OrderHistory, {loader as OrderHistoryLoader} from './pages/OrderHistory';
import ResultHistory, {loader as ResultHistoryLoader} from './pages/ResultHistory';
import DrawLocations, {loader as msg2Loader} from './pages/DrawLocation';
import Cynergy from './pages/Cynergy';
import Success, {loader as orderLoader} from './pages/OrderSuccessful';
import CCFailed from './pages/CreditCardFailed';
import CCiFrameREVSPRING from './pages/CreditCardiFrameREVSPRING';
import CCiFrameCLOVER from './pages/CreditCardiFrameCLOVER';
import CCiFrameXIFIN from './pages/CreditCardiFrameXIFIN';
import TouchNet from './pages/TouchNet';
import BackendTest from './pages/BackendTest';
import { tokenLoader } from './utils/auth';
import { Provider } from "react-redux";
import { createAppStore } from "./store";
import { initTestsThunk } from './store/tests';

import './App.css';



const router = createBrowserRouter([
    {
        path: '/',
        element: <Root/>,
			errorElement: <ErrorPage />,
		    id: 'root',
			
			loader: tokenLoader,
        children: [
            {index: true, element:<Home/>, loader: msgLoader},
            {path: 'systemMsg', element: <SystemMsg/>, loader: sysLoader},
            {path: 'cart', element: <Cart/>, loader: upLoader, action: cartAction},
			{path: 'aaoefrm', element: <AAOE/>},
            {path: 'details/:testID/:page/:testName', element: <TestDetail/>,loader: TILoader },
			{path: 'availableTests', element: <AvailableTests/>},
			{path: 'availableTestwithCat/:page', element: <AvailableTestwithCat/>},
			{path: 'availableTestwithCat', element: <AvailableTestwithCat/>},
			{path: 'login', element: <Login/>, action: loginAction, loader: LoginLoader},
			{path: 'minor', element: <Minor/>},
			{path: 'noService', element: <NoService/>},
			{path: 'noServiceSysMsg', element: <NoServiceSysMsg/>},
			{path: 'register', element: <Register/>,loader: regLoader, action: newRegAction},
			{path: 'activateAccount', element: <ActivateAccount/>,loader: actLoader, action: activateAccountAction},
			{path: 'logout', action: logoutAction},
			{path: 'userProfile', element: <UserProfile/>,loader: UPTFLoader},
			{path: 'userProfileEdit', element: <UserProfileEdit/>,loader: UPTFLoader, action: UPAction},
			{path: 'forgotPassword', element: <ForgotPassword />, action: ForgotPasswordAction},
			{path: 'forgotUsername', element: <ForgotUsername />, action: ForgotUsernameAction},
			{path: 'orderHistory', element: <OrderHistory />,loader: OrderHistoryLoader},
			{path: 'resultHistory', element: <ResultHistory />,loader: ResultHistoryLoader},
			{path: 'resetPassword', element: <ResetPassword />,action: ResetPasswordAction},
			{path: 'drawLocations', element: <DrawLocations />, loader: msg2Loader},
			{path: 'cynergy', element: <Cynergy />},
			{path: 'orderSuccessful', element: <Success />,loader: orderLoader},
			{path: 'creditCardFailed', element: <CCFailed />},
			{path: 'touchNet', element: <TouchNet />},
			{path: 'backendTest', element: <BackendTest />},
        ]
    },
	{
		path: '/CreditCardiFrameREVSPRING/:token',
		element: <CCiFrameREVSPRING />,
	},
	{
		path: '/creditCardiFrameXIFIN/:amt/:fn/:ln/:addr/:zip',
		element: <CCiFrameXIFIN />,
	},
	{
		path: '/creditCardiFrameCLOVER/:amt/:email/:fname/:lname/:refid',
		element: <CCiFrameCLOVER />,
	},

]);

function App() {
	const [colorTheme, setColorTheme] = useState([]);
	const [themeParams,setThemeParams]=useState({});
	const [menuTheme, setMenuTheme] = useState([]);
	const [labid, setLabid] = useState([]);
	const [loading, setLoading] = useState(true);
	const [store, setStore] = useState(null);

  // Read sessionStorage once
  useEffect(() => {
    const LabID = sessionStorage.getItem("LABID");
    setLabid(LabID);            // could be null or a string
    setLoading(false);
  }, []);

  // Create the store once labid is known
  useEffect(() => {
    if (loading || !labid || store) return;
    (async () => {
      const storeInstance = await createAppStore(labid);
      await storeInstance.dispatch(initTestsThunk());
      setStore(storeInstance);
    })();
  }, [loading, labid, store]);

  // Theme variables (guard on labid)
  useEffect(() => {
    if (!labid) return;
    (async () => {
      try {
        const colorVar = await getLabConfig('DTCTHEME');
        const colorVariables = typeof colorVar === 'string' ? JSON.parse(colorVar) : colorVar;
        if (colorVariables && typeof colorVariables === 'object') {
          setThemeParams(colorVariables);
          const supportedKeys = [
            'main-font','primary-color','accent-color','accent2-color','footer-border-top','footer-sp-bg',
            'footer-sp-color','footer-sp-font-size','app-header-sp-font-size','test-text-color','nav-area-color',
            'radius15','radius10','radiusfrm','categories-color','pageimage-url','disabled-bg','disabled-text',
            'card-bg','card-hover-bg','card-text','paging-text-color','headliang-color','card-text-color',
            'info-content-bg','info-content-text','box-shadow','enable-hover','promo','test-hover-text',
            'test-height','secondary-color','hdr-icon-color','hdr-bckgrd-color','hdr-title-size','hdr-icon-size','hdr-icon-nbr-size','banner-color'
          ];
          for (const key of supportedKeys) {
            if (colorVariables[key]) {
              document.documentElement.style.setProperty(`--${key}`, colorVariables[key]);
            }
          }
        }
      } catch (e) {
        console.error("Failed to load color theme:", e);
      }
    })();
  }, [labid]);

  // Menu theme
  useEffect(() => {
    if (!labid) return;
    (async () => setMenuTheme(await getMenuType()))();
  }, [labid]);

  if (loading || !store) return <div>Loading...</div>;

  return (
    <Provider store={store}>
      <LabIDContext.Provider value={labid}>
        <ThemeContext.Provider value={themeParams}>
          <MenuContext.Provider value={menuTheme}>
			<UploadProvider >
				<RouterProvider router={router} />
			</UploadProvider >
          </MenuContext.Provider>
        </ThemeContext.Provider>
      </LabIDContext.Provider>
    </Provider>
  );
}


export default App;